import RichText from '../RichText/RichText';

import type { RichTextAnchorProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/RichTextAnchorProps';

const RichTextAnchor = (props: RichTextAnchorProps) => (
  <RichText {...props.richTextProps} />
);

export default RichTextAnchor;
